import React, { Fragment, useEffect, useState } from 'react';
import { Drawer } from 'antd';
import Header from './Header/Header';
import MenuDiv from './MenuDiv/MenuDiv';
import MenuDiwoIcon from './SVG/MenuDiwoIcon';
import MenuHRIcon from './SVG/MenuHRIcon';
import MenuTimeIcon from './SVG/MenuTimeIcon';
import MenuSalaryIcon from './SVG/MenuSalaryIcon';
import MenuReport from './SVG/MenuReport';
import MenuSocial from './SVG/MenuSocial';
import MenuChat from './SVG/MenuChat';
import SubMenuItem from './SubMenuItem/SubMenuItem';
import MenuSettings from './SVG/MenuSettings';
import SettingsGrantType from './SVG/SettingsGrantType';
import SettingsGrant from './SVG/SettingsGrant';
import SettingsDeduction from './SVG/SettingsDeduction';
import SettingsUsers from './SVG/SettingsUsers';
import MenuMarket from './SVG/MenuMarket';

const Layout = (props) => {

    const [menuType, setMenuType] = useState("");
    const [showSubMenu, setShowSubMenu] = useState(false);
    const [feedbackUnixId, setFeedbackUnixId] = useState();

    useEffect(() => {
        if (props?.feedbackUnixId > 0) {
            setFeedbackUnixId(props?.feedbackUnixId)
        }
    }, [props?.feedbackUnixId])

    const onNav = (pValue) => {
        setShowSubMenu(false);

        let vRefresh = false;
        if (props?.pathname?.indexOf("/hrsuite") >= 0 && pValue?.indexOf("/pr") >= 0) {
            vRefresh = true;
        }

        if (props?.navigate) {
            if (props?.type == "next") {
                props.navigate.push(pValue)
            } else {
                props.navigate(pValue);
            }
        }

        if (vRefresh) {
            window.location.reload();
        }
    }

    const onSubMenu = (pValue) => {
        setShowSubMenu(true);
        setMenuType(pValue);
    }

    let vMenuPanel = null;

    if (menuType == "settings") {
        vMenuPanel = (
            <div>
                {/* <SubMenuItem onClick={() => onNav("/hrsuite/settings/grant")} icon={<SettingsGrant />} text="Нэмэгдэл" />
                <div style={{ marginTop: 10 }}> */}
                <SubMenuItem onClick={() => onNav("/hrsuite/settings/deduction")} icon={<SettingsDeduction />} text="Суутгал" />
                {/* </div> */}
                <div style={{ marginTop: 10 }}>
                    <SubMenuItem onClick={() => onNav("/hrsuite/settings/users")} icon={<SettingsUsers />} text="Хэрэглэгч" />
                </div>
            </div>
        );
    }

    return (
        <div style={{ height: '100vh', width: '100wh', display: 'flex', flexDirection: 'column' }}>
            <Header onFeedback={props.onFeedback} feedbackUnixId={feedbackUnixId} type={props?.type} pathname={props?.pathname} navigate={props?.navigate} onPasswordChange={props?.onPasswordChange} userInfo={props?.userInfo} location={props?.location} userMenu={props?.userMenu} />
            <div style={{ display: 'flex', flex: 1 }}>
                <div style={{ width: 74, backgroundColor: "#4736B4", display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flex: 1 }}>
                        <MenuDiv active={props?.pathname?.indexOf("/hrsuite/home") >= 0} onClick={() => onNav("/hrsuite/home")} icon={<MenuDiwoIcon />} title="Diwo туслах" />
                        <MenuDiv active={(props?.pathname?.indexOf("/hrsuite") >= 0
                            && props?.pathname?.indexOf("/hrsuite/home") < 0
                            && props?.pathname?.indexOf("/hrsuite/report") < 0
                            && props?.pathname?.indexOf("/hrsuite/market") < 0
                            && props?.pathname?.indexOf("/hrsuite/social") < 0
                            && props?.pathname?.indexOf("/hrsuite/chat") < 0
                            && props?.pathname?.indexOf("/hrsuite/settings") < 0)} onClick={() => onNav("/hrsuite")} icon={<MenuHRIcon />} title="Хүний нөөц" />
                        {props?.userInfo?.features?.length > 0 && props?.userInfo?.features?.includes("PAYROLL") ?
                            (<Fragment>
                                <MenuDiv active={props?.pathname?.indexOf("/pr/timedata") >= 0} onClick={() => onNav("/pr/timedata")} icon={<MenuTimeIcon />} title="Цаг бүртгэл" />
                                <MenuDiv active={props?.pathname?.indexOf("/pr/salary") >= 0} onClick={() => onNav("/pr/salary")} icon={<MenuSalaryIcon />} title="Цалин" />
                                <MenuDiv active={props?.pathname?.indexOf("/hrsuite/report") >= 0} onClick={() => onNav("/hrsuite/report")} icon={<MenuReport />} title="Тайлан" />
                                {/* <MenuDiv active={props?.pathname?.indexOf("/hrsuite/social") >= 0} onClick={() => onNav("/hrsuite/social")} icon={<MenuSocial />} title="Сошиал" /> */}
                                {/* <MenuDiv active={props?.pathname?.indexOf("/hrsuite/chat") >= 0} onClick={() => onNav("/hrsuite/chat")} icon={<MenuChat />} title="Чат" /> */}
                            </Fragment>) : null}
                        <div style={{ borderBottom: '1px solid rgba(239, 239, 239, 0.3)', margin: "20px 15px" }}>
                        </div>
                        <MenuDiv active={props?.pathname?.indexOf("/hrsuite/market") >= 0} onClick={() => onNav("/hrsuite/market")} icon={<MenuMarket />} title="Маркет" />
                    </div>
                    <div>
                        <MenuDiv active={props?.pathname?.indexOf("/hrsuite/settings") >= 0} onClick={() => onSubMenu("settings")} icon={<MenuSettings />} title="Тохиргоо" />
                    </div>
                </div>
                <div style={{ flex: 1, overflow: 'auto', position: 'relative' }}>
                    <Drawer
                        width={191}
                        placement="left"
                        closable={false}
                        onClose={() => { setShowSubMenu(false); }}
                        open={showSubMenu}
                        getContainer={false}
                    >
                        {vMenuPanel}
                    </Drawer>
                    {props.children}
                </div>
            </div>
        </div>
    );
}

export default Layout;